import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HideFooterOnScrollDirective } from './hide-footer-on-scroll.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [HideFooterOnScrollDirective],
  exports: [HideFooterOnScrollDirective]
})
export class HideFooterOnScrollModule {}
